import React from 'react';
import '../statusBar.css';
import {connect} from "react-redux";
import {openAdministrationView} from "../../redux/actions";
import User from "../../icons/User";

export const UserIcon = connect(state => {
    return {
        view: state.rootReducer.view,
        mode: state.rootReducer.mode
    }
}, function (dispatch) {
    return {
        openAdministrationView: () => dispatch(openAdministrationView())
    }
})(function (props) {
    if(props.view === 'app' && props.mode !== 'screenSaver'){
        return (
            <div id={"userIcon"} onClick={e => {props.openAdministrationView();}}>
                <User/>
            </div>
        );
    }
    return <div/>;
});